module.exports = __webpack_public_path__ + "static/media/mike.f03f6967.jpg";